import { render, staticRenderFns } from "./saleStat.vue?vue&type=template&id=9ca2b3de&"
import script from "./saleStat.vue?vue&type=script&lang=js&"
export * from "./saleStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports